import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
// import { ContactForm } from './ContactForm';
import { Content } from './Content';
import { theme, media, color } from '../theme';
import { useConfig, vr } from '../utils';
import logo from '../img/logo.png';
import logo2x from '../img/logo@2x.png';
import logo3x from '../img/logo@3x.png';

export function Footer({ hideContactForm }) {
  const { title } = useConfig();

  const { content, files } = useStaticQuery(
    graphql`
      query {
        content: mdx(fields: {slug: {eq: "/footer/"}}) {
          body
        }

        files: allFile(filter: {extension: {eq: "md"}, relativeDirectory: {eq: "diverse"}, childMdx: {frontmatter: { parent: {eq: null}}}}, sort: {order: ASC, fields: childMdx___frontmatter___title}) {
          nodes {
            childMdx {
              fields {
                slug
              }
              frontmatter {
                title
              }
            }
          }
        }
      }
    `,
  );

  const links = files?.nodes ? files.nodes : [];

  return (
    <FooterComponent>
      <div className="container">
        <div className="info">
          <div data-section="openinghours">
            <h2>Åbningstider</h2>
            <Content>{content.body}</Content>
          </div>
          {/* { hideContactForm !== true && (
            <div data-section="contact">
              <h2>Kontakt</h2>
              <ContactForm />
            </div>
          )} */}
        </div>
        {links.length > 0 && (
          <Links>
            <h2>Links</h2>
            <ul className="noBullets">
              {links.map(({ childMdx: { frontmatter, fields } }) => (
                <li key={`footer-${fields.slug}`}>
                  <Link to={`${fields.slug}`}>{frontmatter.title}</Link>
                </li>
              ))}
            </ul>
          </Links>
        )}
        <div className="notabene">
          <img src={logo} srcSet={`${logo2x} 2x, ${logo3x} 3x`} width={theme.headerLogoSize} alt={`${title} logo`} />
          <span className="stylized">{title}</span>
          <span className="stylized">Brillerne 9, Gl. Holte</span>
          <span className="stylized">DK-2840 Holte</span>
        </div>
      </div>
    </FooterComponent>
  );
}

const FooterComponent = styled.footer`
  background: ${theme.footerBackgroundColor};
  padding: ${vr(2)} 0;

  a {
    color: ${color.white};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    margin-bottom: ${vr(1.5)};

    @media ${media.tabletS} {
      flex-direction: row;
    }

    [data-section="openinghours"] {
      
      @media ${media.tabletS} {
        width: 50%;
      }
    }

    [data-section="contact"] {
      margin-top: ${vr(2)};
      
      @media ${media.tabletS} {
        width: 50%;
        margin-top: 0;
      }
    }
  }

  strong, p, label, span, h2, h3 {
    color: ${color.offwhite};
  }

  strong, span, p, label, h3, input:not([type="submit"]), textarea {
    font-size: .9rem;
  }

  p {
    margin-top: 0;
  }

  h2 {
    margin-top: ${vr(1)};
  }

  h3 a {
    display: none;
  }

  .notabene {
    display: block;
    text-align: center;

    img {
      width: 64px;
      height: 64px;
      margin: 0 auto ${vr(0.5)};
      display: block;
    }
  }
`;

const Links = styled.div`
  padding-bottom: ${vr(0.5)};

  h2 {
    display: block;
    margin: 0;
  }

  ul {
    margin-top: 1rem;
    font-size: .9em;
  }

  li {
    margin-top: 0 !important;
    display: inline-block;
    padding: 0 ${vr(1)} 0 0;
  }
`;
